/**
* 左边菜单
*/ 
<template>
  <el-menu
    default-active="2"
    :collapse="collapsed"
    collapse-transition
    unique-opened
    class="el-menu-vertical-demo"
    background-color="#334157"
    text-color="#fff"
    active-text-color="#ffd04b"
  >
    <div class="logobox">
      <img class="logoimg" src="../assets/img/logo.png" alt="" />
    </div>

    <el-menu-item
      v-for="menu in menus"
      @click.native="handleJump(menu.url)"
      :key="menu.menuid"
      :index="menu.url"
    >
      <template slot="title">
        <i class="iconfont" :class="menu.icon"></i>
        <span>{{ menu.menuname }}</span>
      </template>
    </el-menu-item>
  </el-menu>
</template>
<script>
export default {
  name: "leftnav",
  data() {
    return {
      collapsed: false,
      menus: [],
      produceDataMenu: [
        {
          menuid: 3,
          icon: "li-icon-shangchengxitongtubiaozitihuayuanwenjian91",
          menuname: "生产数据管理",
          hasThird: null,
          url: "/produceDataManage/index",
        },
      ],
      allmenu: [
        {
          menuid: 0,
          icon: "li-icon-shangchengxitongtubiaozitihuayuanwenjian91",
          menuname: "流程列表",
          hasThird: null,
          url: "/processManage/index",
        },
        {
          menuid: 1,
          icon: "li-icon-shangchengxitongtubiaozitihuayuanwenjian91",
          menuname: "账号管理",
          hasThird: null,
          url: "/accountManage/index",
        },
        {
          menuid: 2,
          icon: "li-icon-shangchengxitongtubiaozitihuayuanwenjian91",
          menuname: "打印管理",
          hasThird: "N",
          url: "/printerManage/index",
        },
        {
          menuid: 3,
          icon: "li-icon-shangchengxitongtubiaozitihuayuanwenjian91",
          menuname: "生产数据管理",
          hasThird: null,
          url: "/produceDataManage/index",
        },
      ],
    };
  },
  // 创建完毕状态(里面是操作)
  created() {
    // 获取图形验证码
    if (localStorage.getItem("role_id") == "0") {
      this.menus = this.allmenu;
    } else if (localStorage.getItem("role_id") == "1") {
      this.menus = this.produceDataMenu;
    }
    this.$root.Bus.$on("toggle", (value) => {
      this.collapsed = !value;
    });
  },
  methods: {
    handleJump(url) {
      this.$router.push(url);
    },
  },
};
</script>
<style>
.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 240px;
  min-height: 400px;
}
.el-menu-vertical-demo:not(.el-menu--collapse) {
  border: none;
  text-align: left;
}
.el-menu-item-group__title {
  padding: 0px;
}
.el-menu-bg {
  background-color: #1f2d3d !important;
}
.el-menu {
  border: none;
}
.logobox {
  height: 40px;
  line-height: 40px;
  color: #9d9d9d;
  font-size: 20px;
  text-align: center;
  padding: 20px 0px;
}
.logoimg {
  height: 40px;
}
</style>


// WEBPACK FOOTER //
// src/components/leftnav.vue